import { render } from "./TemplateDetails.vue?vue&type=template&id=58ca38b8&ts=true"
import script from "./TemplateDetails.vue?vue&type=script&lang=ts"
export * from "./TemplateDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__